import React, { FC, useState } from 'react'
import Autocomplete from '../autocomplete'
import useDebounce from 'src/shared/hooks/useDebounce'
import { useGetProjectTemplatesQuery } from '../../../old-app/service/Projects'

interface IProps {
	value: any
	placeholder?: string
	onChange: (value: any) => void
	isIds?: boolean
	multiple?: boolean
}

const ProjectTemplatesChoice: FC<IProps> = (p) => {
	const { value, onChange, placeholder = 'Шаблон', isIds, multiple = false } = p

	const [search, setSearch] = useState<string>('')
	const debounceSearch = useDebounce(search, 300)

	const { data: projectTemplatesData } = useGetProjectTemplatesQuery({ name: debounceSearch })

	const list: any[] = projectTemplatesData?.data ?? []

	const onInputChange = (event: React.SyntheticEvent, value: string, reason: string) => {
		setSearch(value)
	}

	return (
		<Autocomplete
			multiple={multiple}
			placeholder={placeholder}
			// TODO: Вынести в отдельную функцию
			optionLabel={(option: any) => option?.name}
			renderOptionLabel={(option: any) => option?.name}
			list={list}
			onInputChange={onInputChange}
			value={value}
			onChange={onChange}
		/>
	)
}

export default ProjectTemplatesChoice
